import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useDataProvider } from "react-admin";
import { employeeRequests } from "api/employeeApi";
import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const useRemainingVacationDays = employeeId => {
  const dataProvider = useDataProvider();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    // employeeId is sent only when an admin requests for another employee; otherwise the endpoint returns the current user's balance.
    dataProvider
      .customRequest(employeeRequests.getRemainingVacationDays(employeeId), null, "GET")
      .then(({ data }) => { if (!cancelled) setData(data ?? []); })
      .catch(err => { if (!cancelled) { setData([]); setError(true); console.error(err); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [employeeId, dataProvider]);

  return { data, loading, error };
};

const RemainingVacationDaysTable = ({ employeeId }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const { data, loading, error } = useRemainingVacationDays(employeeId);

  return (
    <>
      <SectionTitle
        title="Оставащи дни отпуск"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Box
        sx={{
          ...(isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox),
          width: "auto",
          maxWidth: "none", // shadowBox's cap assumes its 2rem side margins, which are dropped here
          margin: "0.5rem 0 1rem 0",
        }}
      >
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" my={4}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Typography color="error" sx={{ textAlign: "center", py: 2 }}>
            Проблем с извличането на оставащи отпуски
          </Typography>
        ) : data.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ textAlign: "center", py: 2 }}>
            Няма данни
          </Typography>
        ) : (
          <TableContainer>
            <Table size="small" sx={settings.style.customDatagridStyle}>
              <TableHead>
                <TableRow>
                  <TableCell>Година</TableCell>
                  <TableCell align="center">Полагаем отпуск</TableCell>
                  <TableCell align="center">Използван отпуск</TableCell>
                  <TableCell align="center">Оставащ отпуск</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow key={row.year ?? index}>
                    <TableCell>{row.year}</TableCell>
                    <TableCell align="center">{row.entitledLeave}</TableCell>
                    <TableCell align="center">{row.usedLeave}</TableCell>
                    <TableCell align="center" sx={{ fontWeight: "bold" }}>{row.remainingLeave}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    </>
  );
};

export default RemainingVacationDaysTable;
